import AgendaItem from "@/domain/entities/agenda/AgendaItem";
import useGetUserProfile from "@/hooks/useGetUserProfile";
import { cn } from "@/lib/utils";
import { format } from "date-fns";
import { Clock } from "lucide-react";
import { EventProps } from "react-big-calendar";
import getClassNameFromUserAcceptedStatus from "./getEventClassName";

type CalendarEventCardProps = {
    event: EventProps<AgendaItem>;
};

const CalendarEventCard = ({ event }: CalendarEventCardProps) => {
    const { data: user } = useGetUserProfile();

    if (!user) {
        return null;
    }

    const userAcceptedStatus = event.event.getUserAcceptedStatus(user);

    return (
        <div
            className={cn(
                "flex h-full flex-col gap-1 overflow-hidden rounded-lg border-2 border-primary-dark border-white/10 bg-gray-100 p-1 text-gray-800",
                getClassNameFromUserAcceptedStatus(userAcceptedStatus),
            )}
        >
            <div
                className={cn(
                    event.event.isCancelled && "line-through",
                    "font-medium",
                )}
            >
                {event.event.subject}
            </div>
            {!event.event.isAllDayEvent() && !event.event.isOnSeveralDays() && (
                <div className="flex items-center gap-1 pl-1 opacity-80">
                    <Clock className="mt-[-2px] h-3 w-3" />
                    <p>
                        {format(event.event.start, "HH:mm")}
                        {" -> "}
                        {format(event.event.end, "HH:mm")}
                    </p>
                </div>
            )}
        </div>
    );
};

export default CalendarEventCard;
